import { PlanIntervalUnit } from 'src/lib/types/subscriptions'

/** Price delta bounds. Bounds come from design; the contract only types it as a number. */
export const DELTA_MIN = 1
export const DELTA_MAX = 2
export const DELTA_DEFAULT = 1.2

/**
 * Both the interval ("deliver every N") and the duration ("for N") are capped at
 * one year, so the ceiling depends on the unit: 12 months or 52 weeks. Anything
 * unit-agnostic here would either cut weekly plans off at three months or let
 * monthly plans run for 52 years.
 */
export const PLAN_UNIT_MAX: Record<PlanIntervalUnit, number> = {
  WEEK: 52,
  MONTH: 12
}

export const INTERVAL_COUNT_MIN = 1
export const DURATION_MIN = 1
export const DURATION_DEFAULT = 6

/** A single delivery is a one-time purchase, not a subscription. */
export const MIN_CYCLES = 2

export const NAME_MAX_LENGTH = 60

export const PERCENTAGE_MAX = 100
export const FLAT_MAX = 999999

export const INTERVAL_UNIT_OPTIONS: { value: PlanIntervalUnit; label: string }[] = [
  { value: 'WEEK', label: 'Week' },
  { value: 'MONTH', label: 'Month' }
]

export const INTERVAL_UNIT_LABELS: Record<PlanIntervalUnit, { singular: string; plural: string }> = {
  WEEK: { singular: 'week', plural: 'weeks' },
  MONTH: { singular: 'month', plural: 'months' }
}

export const INTERVAL_UNIT_SELECT_WIDTH = 220
